module.exports = __webpack_public_path__ + "img/kalalla_venessa.afcc8a00.jpg";